import { IFloodgateFeatureStatusCallback } from "@ms-ofb/floodgate-shared-typings";

let featureGateProvider: IFloodgateFeatureStatusCallback;

export function setFeatureGateProvider(provider: IFloodgateFeatureStatusCallback) {
	featureGateProvider = provider;
}

export function getFeatureGateProvider() {
	return featureGateProvider;
}